<template>
  <div>
    <div class="header" :style="[{ maxHeight: threshold + 100 + 'px' }]">
      <div class="a1"></div>
      <div class="a2">
        <div :style="[{ height: threshold + 'px' }]" />
        <h2 id="title">
          {{ title }}
        </h2>
      </div>
    </div>
  </div>
</template>
 <script>
import { getToken } from "@/utils/auth";
export default {
  computed: {
    title() {
      return this.$store.getters.headerTitle;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    hasToken() {
      return this.$store.getters.token != "" && getToken();
    },
    threshold() {
      return this.isMobile ? 130 : 300;
    },
  },
  watch: {
    isMobile(value, oldValue) {
      if (value && !oldValue) {
        let scroll = window.scrollY;

        document.querySelector("#title").style.marginRight =
          Math.min((scroll * 50) / this.threshold + 50, 100) + "px";
      } else if (!value && oldValue) {
        document.querySelector("#title").style.marginRight = "50px";
      }
    },
  },

  methods: {
    handleScroll(event) {
      // Any code to be executed when the window is scrolled
      let value = window.scrollY;

      if (this.isMobile && this.hasToken) {
        document.querySelector("#title").style.marginRight =
          Math.min((value * 50) / this.threshold + 50, 100) + "px";
      }
      document.querySelector("#title").style.fontSize =
        Math.max(1.5 - (value * 0.3) / this.threshold, 1.2) + "em";

      document.querySelector(".a1").style.opacity = Math.max(
        0.4,
        1 - value / 1000
      );
      let opacity = Math.min(1, value / (this.threshold - 30));
      document.querySelector(".a2").style.backgroundColor =
        "rgba(51,153,255," + opacity + ")";

      document.querySelector(".header").style.top =
        Math.min(this.threshold - 30, value) * -1 + "px";
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
#title {
  color: white;
  padding-bottom: 25px;
  margin-right: 50px;
  font-size: 1.5em;
}

.header {
  

  min-height: 100px;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* .a1 {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 300px;
  right: 0;
  background: url("../assets/12.jpg");
  background-size: 100% 100%;
} */
</style>